module.exports = __webpack_public_path__ + "img/8.038e29e4.jpg";